import React, { useCallback } from "react";

// router
import { useNavigate } from "react-router";

// state
import { useSelector } from "react-redux";

// prime components
import { Dialog } from "primereact/dialog";

import { Button } from "primereact/button";

// utils
import { resetState } from "utils/login";
import { logout } from "utils/common";

const TokenExpire = () => {
  const expired = useSelector((state) => state.loginDetails.expired);
  const userNotExistError = useSelector(
    (state) => state.loginDetails.userNotExistError
  );

  const navigate = useNavigate();

  const login = useCallback(() => {
    resetState();
    navigate("/login");
  }, [navigate]);

  const handleLogout = useCallback(async () => {
    await logout(false);
    navigate("/login");
  }, [navigate]);

  // Show dialog if either expired or userNotExistError is true
  const showDialog = expired || userNotExistError ;
  return (
    <div>
      <Dialog
        showHeader={false}
        className="token-expire-popup"
        position="top"
        visible={showDialog}
        onHide={() => {}}
      >
        <div className="text-center my-2 token-expire-box">
          {userNotExistError
            ? "User doesn't exist! Please enter valid user id."
            : "Session has been expired!"}
        </div>
        <div className="token-expire-login">
          {userNotExistError ? (
            <Button
              type="submit"
              label="Login with another account"
              className="p-button p-button-primary p-mt-4 p-mb-2"
              onClick={handleLogout}
            />
          ) : (
            <Button
              type="submit"
              label="Login"
              className="p-button p-button-primary p-mt-4 p-mb-2"
              onClick={login}
            />
          )}
        </div>
      </Dialog>
    </div>
  );
};

export default TokenExpire;
